{
	"showButtonTitle": "Show",
	"hideButtonTitle": "Hide"
}
